import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 24px;
  margin: 16px 0;

  @media (${breakpoint.mdMin}) {
    margin: 32px auto 20px auto;
    padding: 0;
  }

  @media (${breakpoint.xlMin}) {
    width: 100%;
  }
`;

export const Footnote = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  padding: 4px 0;
  font-size: 14px;
  letter-spacing: 0.58px;
  line-height: 21px;
  word-wrap: break-word;
`;

export const Table = styled.table<{ theme: Theme }>`
  margin: 20px 0 0;
  width: 100%;
  border-spacing: 0;

  td {
    padding: 10px;
  }

  tfoot {
    font-size: 14px;
    letter-spacing: 0.576px;
    line-height: 21px;
    overflow-wrap: break-word;
    text-align: right;
  }

  a {
    color: ${getColor('textLink')};
  }

  h3 {
    padding-left: 10px;
  }
`;

export const RowTable = styled.tr<{ theme: Theme }>`
  padding: 10px 0;

  &:nth-child(even) {
    background-color: ${getColor('surfaceSecondary')};
  }

  &:hover {
    background-color: ${brandColors.own.surfaceBrand};
  }

`;

export const Label = styled.td<{ theme: Theme }>`
  color: ${getColor('textSecondary')};
`;

export const Value = styled.td`
  text-align: right;
`;
